(function () {
  'use strict';
  if (window.__pocoBuyNow) return;
  window.__pocoBuyNow = true;

  // Add to cart loading: swap cart icon for the spinner (text stays).
  (function () {
    var s = document.createElement('style');
    s.textContent = '.product-form__submit.loading > svg{display:none!important}' +
      '.product-form__submit.loading .loading__spinner:not(.hidden){display:inline-flex!important}';
    document.head.appendChild(s);
  })();

  function atcOf(btn) {
    var wrap = btn.closest('.product-form__buttons');
    return wrap ? wrap.querySelector('.product-form__submit') : null;
  }

  function sync(btn) {
    var atc = atcOf(btn);
    if (!atc) return;
    // While Add to cart is busy (.loading), aria-disabled is set temporarily:
    // keep Buy now visible, just block clicks. Only hide on real sold-out/unavailable.
    var busy = atc.classList.contains('loading');
    var off = atc.hasAttribute('disabled') || (!busy && atc.getAttribute('aria-disabled') === 'true');
    btn.toggleAttribute('disabled', off);
    btn.style.pointerEvents = busy ? 'none' : '';
  }

  function showError(form, msg) {
    var pf = form.closest('product-form') || form.parentElement;
    var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    var out = wrap && wrap.querySelector('.product-form__error-message');
    if (wrap && out) {
      out.textContent = msg;
      wrap.hidden = false;
    } else {
      window.alert(msg);
    }
  }

  function buy(btn) {
    var form = btn.closest('form');
    if (!form || btn.hasAttribute('disabled') || btn.classList.contains('loading')) return;
    var atc = atcOf(btn);
    if (atc && atc.classList.contains('loading')) return;
    if (form.reportValidity && !form.reportValidity()) return;

    var fd = new FormData(form);
    fd.delete('sections');
    fd.delete('sections_url');

    btn.classList.add('loading');
    btn.setAttribute('aria-busy', 'true');

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          throw new Error(res.data.description || res.data.message || (window.cartStrings && window.cartStrings.error) || 'Could not add this item.');
        }
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-busy');
        showError(form, err.message);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-poco-buynow]');
    if (!btn) return;
    e.preventDefault();
    buy(btn);
  });

  function watch() {
    document.querySelectorAll('[data-poco-buynow]').forEach(function (btn) {
      if (btn.dataset.watched) return;
      btn.dataset.watched = '1';
      sync(btn);
      var atc = atcOf(btn);
      if (atc && 'MutationObserver' in window) {
        new MutationObserver(function () { sync(btn); })
          .observe(atc, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('shopify:section:load', watch);
  if ('MutationObserver' in window) {
    var q = false;
    new MutationObserver(function () {
      if (q) return;
      q = true;
      requestAnimationFrame(function () { q = false; watch(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();